import { render } from "./EducationMain.vue?vue&type=template&id=c4cb1bae"
import script from "./EducationMain.vue?vue&type=script&lang=js"
export * from "./EducationMain.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__